export { default as PlusSolidIcon } from './PlusSolidIcon';
